<template>
  <DefaultLayout>
    <template #sidebar>
      <SideBar
        :items="items"
        :header="{ logo: Logo, name: 'DWM', to: '/' }"
        :support="{
          icon: Telegram,
          title: $i18n.t('support'),
          to: 'https://t.me/DT_ECOSYSTEM_SUPPORT',
        }"
      />
    </template>
    <template #main>
      <RouterView v-if="accessToView" />
    </template>
  </DefaultLayout>
</template>

<script>
import { LANGUAGES } from "@/utils/constants";
import { SideBar, DefaultLayout } from "@dt-ecosystem/ui/packages/vue2/dist";
import Logo from "../assets/icon/Logo.vue";
import Telegram from "../assets/icon/Telegram.vue";

import { AUTH_LOGOUT_URL, IS_DEV } from "@/config";

export default {
  name: "MainLayout",
  components: { SideBar, DefaultLayout },
  props: {
    source: String,
  },
  data() {
    return {
      Logo,
      Telegram,
      items: [],
      drawer: null,
      currentUserAction: null,
      userDataLoading: false,
    };
  },
  methods: {
    async navigationFromBackEnd() {
      this.showLoading();
      try {
        const {
          data: { data: navigationItem },
        } = await this.$http.get("/menus/by-user");
        const navigations = [];

        for (let i in navigationItem) {
          navigations.push({
            title: navigationItem[i][`name_${this.$i18n.locale}`],
            icon: navigationItem[i].icon,
            to: navigationItem[i].url,
            children: null,
          });
          if (navigationItem[i].hasChild) {
            navigations[i].children = navigationItem[i].child.map((child) => {
              return {
                title: child[`name_${this.$i18n.locale}`],
                icon: child.icon,
                to: child.url,
              };
            });
          }
        }

        this.items = navigations;
      } catch (e) {
        const {
          /**
           * @type {Object}
           * @property {function} setErrors
           */
          formObs,
        } = this.$refs;
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.message
        ) {
          formObs.setErrors({
            id: this.$t(
              `serverErrorMessages.${e.response.data.errors.message}`
            ),
          });
        }
      } finally {
        this.clearLoading();
      }
    },
    async getNotificationList() {
      try {
        const { data } = await this.$http.get("notification/list", {
          params: { page: 0, limit: 200 },
        });
        console.log(data);
        this.notReaded = data.data.unreadCount;
        this.$store.state.user.notificationCount = this.notReaded;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    logOut() {
      this.$store.commit("clearUserData");
      if (!IS_DEV) {
        window.location.href = AUTH_LOGOUT_URL;
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
  async mounted() {
    await this.navigationFromBackEnd();
    // await this.getNotificationList();
  },
  watch: {
    "$i18n.locale"() {
      this.navigationFromBackEnd();
    },
  },
  computed: {
    accessToView() {
      return this.$store.getters.accessToView;
    },
    LANGUAGES() {
      return LANGUAGES;
    },
    /**
     * @typedef User {Object}
     * @property shortName {string}
     * @property userName {string}
     * @return User
     */
    user() {
      return this.$store.getters.user;
    },
    userActions() {
      return [
        {
          text: this.$t("profile"),
          value: "profile",
        },
        {
          text: this.$t("logOut"),
          value: "logOut",
        },
      ];
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  beforeDestroy() {
    this.$store.commit("clearTimerRefreshToken");
  },
};
</script>
<style lang="scss">
.sidebar-side {
  .header-title {
    margin-bottom: 0 !important;
    color: white !important;
  }

  .children-div {
    color: #a2a5b9 !important;
  }

  .support a {
    color: #fff !important;
    text-decoration: none !important;
  }

  .toolbar {
    a {
      color: #fff !important;
    }

    .child a {
      color: #a2a5b9 !important;
    }
  }
}
</style>
